"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignagePlayEventSchema = exports.MediaLibraryPlayEventSchema = exports.AnnouncementPlayEventSchema = exports.AdPlayEventSchema = void 0;
const zod_extensions_1 = require("@reachmedianetwork/zod-extensions");
exports.AdPlayEventSchema = zod_extensions_1.z.object({
    Type: zod_extensions_1.z.literal('ad'),
    Id: zod_extensions_1.z.number().or(zod_extensions_1.z.string()),
    Name: zod_extensions_1.z.string(),
    WidgetId: zod_extensions_1.z.number().or(zod_extensions_1.z.string()),
    StartTimeUtc: zod_extensions_1.z.number(),
    Duration: zod_extensions_1.z.string(),
});
exports.AnnouncementPlayEventSchema = zod_extensions_1.z.object({
    Type: zod_extensions_1.z.literal('announcement'),
    Duration: zod_extensions_1.z.string(),
    FacilityId: zod_extensions_1.z.number().or(zod_extensions_1.z.string()),
    Id: zod_extensions_1.z.number(),
    MediaLibraryItemId: zod_extensions_1.z.null(),
    Name: zod_extensions_1.z.string(),
    ScreenId: zod_extensions_1.z.number().or(zod_extensions_1.z.string()),
    StartTimeUtc: zod_extensions_1.z.number(),
    WidgetId: zod_extensions_1.z.number(),
});
exports.MediaLibraryPlayEventSchema = zod_extensions_1.z.object({
    Type: zod_extensions_1.z.literal('media_library'),
    Duration: zod_extensions_1.z.string(),
    FacilityId: zod_extensions_1.z.number().or(zod_extensions_1.z.string()),
    Id: zod_extensions_1.z.number(),
    MediaLibraryItemId: zod_extensions_1.z.number().or(zod_extensions_1.z.string()),
    Name: zod_extensions_1.z.string(),
    ScreenId: zod_extensions_1.z.number().or(zod_extensions_1.z.string()),
    StartTimeUtc: zod_extensions_1.z.number(),
    WidgetId: zod_extensions_1.z.number(),
});
exports.SignagePlayEventSchema = zod_extensions_1.z.union([
    exports.AdPlayEventSchema,
    exports.AnnouncementPlayEventSchema,
    exports.MediaLibraryPlayEventSchema,
]);
//# sourceMappingURL=signagePlayEvent.js.map